/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_Guide_BrowseInputs */

const en_google_drive_guide_browse = /** @type {(inputs: Google_Drive_Guide_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Browse in Listening`)
};

const es_google_drive_guide_browse = /** @type {(inputs: Google_Drive_Guide_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Explora en Listening`)
};

/**
* | output |
* | --- |
* | "2. Browse in Listening" |
*
* @param {Google_Drive_Guide_BrowseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_guide_browse = /** @type {((inputs?: Google_Drive_Guide_BrowseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_Guide_BrowseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_guide_browse(inputs)
	return en_google_drive_guide_browse(inputs)
});